module.exports = __webpack_public_path__ + "static/media/RPFPC-logo.7e12c01f.png";